export default "__VITE_ASSET__DPEQunYF__"